import React, { useEffect, useState } from 'react';
import './colorpicker.css';
import COLORS from '../../config/colors_sorted.json';
import invertColor from '../../Util/invertColor.js';
/**
 * Creates a color select tag.
 * state:
 * active: {
 *  name: color name
 *  hex: color hex
 *  txtColor: color for text hex
 * }
 * this is just a COLORS lookup with a wrapper to save the name with it
 * notes:
 * id is for the onChange data
 */
const ColorPicker = ({ name, title, id=null, onChange=null, color='White' }) => {    
    const color_initial = COLORS[color] ? {name:color, ...COLORS[color]} : null;
    const [active, setActive] = useState( color_initial );
    
    function OptionClicked( e ){
        const new_color = e.target.value;
        setActive({name: new_color, ...COLORS[new_color]});
        if (onChange) onChange( e );
    }
    
    return (
    <label htmlFor={name}>{title}
    <div  className={'colorpicker-container'} style={{'backgroundColor':`#${active.hex}`}}>
        <select            
            id={name}
            data-id={id}
            name={name}
            value={active.name}
            className='colorpicker'
            onChange={OptionClicked}
            style={{'color': `#${active.txtColor}`}}
        >
            {Object.entries(COLORS).map( ([k,v], i) => {
                const { hex, txtColor } = v;                
                return (
                    <option                        
                        key={i} name={k} value={k} 
                        style={{ backgroundColor:`#${hex}`, color:`#${txtColor}` }}
                        className='colorpicker-option'
                    >{k}</option>
                )} )}
        </select>
    </div>
    </label>
    )
}

export default ColorPicker;